import { useEffect, useRef } from "react";
import { replaceWithDataSource } from "../helpers/variable";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";

export default function CustomHTML ({ cue }) {
  const iframeRef = useRef()
  let { projectId } = useParams()
	const dynamicText = useSelector(
		(state) => state.main?.projects?.[projectId]?.dynamicText
	);
	const dynamicLists = useSelector(
		(state) => state.main?.projects?.[projectId]?.dynamicLists
	);

  useEffect(()=>{
    if(iframeRef?.current && iframeRef?.current?.contentWindow && iframeRef?.current?.contentWindow?.play) {
      if(cue.status === 'onair') {
        iframeRef?.current?.contentWindow?.play?.()
      } else if (cue.status === 'going') {
        iframeRef?.current?.contentWindow?.play?.()
      } else if (cue.status === 'offair') {
        iframeRef?.current?.contentWindow?.stop?.()
      }
    }
  }, [iframeRef, cue.status])

  useEffect(()=>{
    if(iframeRef?.current && iframeRef?.current.contentWindow && iframeRef?.current.contentWindow.update) {
      Object.entries(cue.data || {}).map(([key, value]) => {
        return iframeRef?.current?.contentWindow.update(JSON.stringify({[key]: replaceWithDataSource(value, dynamicText, dynamicLists) || ""}))
      })
    }

  }, [iframeRef, cue.data, dynamicText, dynamicLists])

  return (
    <iframe
      className={`webpage_key flex
        w-screen
        h-screen
        overflow-none
      `}
      ref={iframeRef}
      title={cue.name}
      src={`/media/${cue.html.filename}`}
      onLoad={()=>console.log('iframe loaded')}
    ></iframe>
  )
}